import { useState } from "react"
import { useEchoPublic } from "@laravel/echo-react"
import { Link } from "@inertiajs/react"

import { getPlaceholderImage } from "./data/photo-data"
import { SoldLabel } from "../icons/sold-label"
import { Image } from "../Common/Image"

export const CarouselItem = ({ data }) => {
    const [item, setItem] = useState(data)
    const images = item?.gun ? item.gun.photo_array : item.photo_array

    useEchoPublic(`App.Models.Auction.${item.id}`, "AuctionUpdated", (e) =>
        setItem(e.auction)
    )

    if (!item.gunbroker_item_id) {
        return null
    }

    return (
        <Link
            href={route("item", { auction: item.gunbroker_item_id })}
            className="block relative shadow-md rounded-[12px] h-[300px] lg:h-[450px] xl:h-[420px] flex flex-col justify-between"
        >
            <div className="flex flex-col justify-around rounded bg-white">
                <div className="relative pt-2">
                    <Image
                        src={images?.[0] ?? null}
                        alt={item.gun?.title_for_gunbroker}
                        className="relative z-0 rounded-t-[12px] w-full h-auto"
                        width={576}
                        height={324}
                        sizes="(min-width:1024px) 300px, 50vw"
                        fallbackSrc={getPlaceholderImage(item.id)}
                    />
                    <div className="absolute rounded bg-white rotate-[346deg] opacity-90 top-[17px] left-2 lg:top-[40px] lg:left-[14px] text-red-500 w-[38px] h-[19px] lg:h-10 lg:w-20"></div>
                    <div className="absolute rounded top-3 left-1 lg:top-8 lg:left-2 text-red-500 w-12 h-12 lg:w-24 lg:h-24">
                        <SoldLabel />
                    </div>
                </div>
                <div className="m-2 mx-4">
                    <p className="text-xs lg:text-xl lg:text-sm font-bold">
                        {item.gun.title_for_gunbroker}
                    </p>
                </div>
            </div>

            <span className="text-xs lg:text-lg font-medium p-4">{`${
                item.gun.overall_condition ? item.gun.overall_condition : ""
            } ${
                item.gun.submodel_verified
                    ? "• " + item.gun.submodel_verified
                    : ""
            }`}</span>
        </Link>
    )
}
